import { Grid } from "@material-ui/core";
import React from "react";
import CustomButton from "../Button";
import EditIcon from "../../../assets/images/redEditIcon.png";

import DeleteIcon from "../../../assets/icons/delete.svg";
export default function ViewButtons(props) {
  const { editMethod, deleteMethod } = props;

  return (
    <Grid container style={{ marginLeft: "25px", marginBottom: "32px" }}>
      <Grid
        item
        lg={12}
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <div>
          {deleteMethod && (
            <CustomButton
              type="button"
              btnProps={{
                text: [
                  <img
                    src={DeleteIcon}
                    alt="Delete Icon Image"
                    key={0}
                    className="view-button-icon"
                  />,
                  "Delete",
                ],
                variant: "contained",

                className: "view-button-new view-button-delete mb-4",
                onClick: deleteMethod,
              }}
            />
          )}
          {editMethod && (
            <CustomButton
              type="button"
              btnProps={{
                text: [
                  <img
                    src={EditIcon}
                    alt="Edit Icon Image"
                    key={0}
                    className="view-button-icon"
                  />,
                  "Edit",
                ],
                variant: "contained",
                className: "view-button-new mb-4 ml-4 view-button-delete",

                onClick: editMethod,
              }}
            />
          )}
          {editMethod && deleteMethod && (
            <React.Fragment>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </React.Fragment>
          )}
        </div>
      </Grid>
    </Grid>
  );
}
